module.exports = __webpack_public_path__ + "media/icons/desktop-smartphone-277597c1.png";